<template>
    <div>

        <v-row v-if="!itens.length">
            <v-col
                    style="height: 20rem; cursor: pointer;"
            >
                <v-progress-linear
                        indeterminate
                        rounded
                ></v-progress-linear>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                    v-for="(cartaz, k) in itens"
                    :key="k"
                    cols="2"
                    style="height: 20rem; cursor: pointer;"
                    @click="emitItem(cartaz)"
                    align="center"
            >
              <v-card
                  class="fill-height"
              >
                <div class="text--secondary text-h6">{{cartaz.nome}}</div>
                <Cartaz :divisao-quadro-atual-loop=cartaz></Cartaz>
              </v-card>
            </v-col>
        </v-row>

    </div>
</template>

<script>
    import Cartaz from "./Cartaz";

    export default {
        name: "ModelosCartaz",
        components: {Cartaz},
        props: {
            value: {
                type: String,
                required: false
            },
        },

        data() {
            return {
                itens: [],
                modeloEmBranco: {
                    nome: "modelo em branco",
                    componenteDados: {id: 0},
                    configs: {
                        "divisaoTelaCheia": false,
                        "divisaoStyle": {"background-color": ""},
                        "cabecalhoTexto": "",
                        "cabecalhoTextoClass": {
                            "size": "",
                            "align": "text-left",
                            "decoration": "",
                            "weight": "",
                            "italic": "",
                            "estilo": []
                        },
                        "cabecalhoImg": "",
                        "cabecalhoStyle": {
                            "color": "",
                            "background-color": "",
                            "text-align": "center",
                            "fontFamily": ""
                        },
                        "meioImg": "",
                        "meioStyle": {"background-color": ""},
                        "rodapeTexto": "",
                        "rodapeTextoClass": {
                            "size": "",
                            "align": "",
                            "decoration": "",
                            "weight": "",
                            "italic": "",
                            "estilo": []
                        },
                        "rodapeImg": "",
                        "rodapeStyle": {
                            "color": "",
                            "background-color": "",
                            "text-align": "",
                            "fontFamily": ""
                        }
                    }
                },
            }
        },

        mounted() {
            this.getFromApi();
        },

        methods: {
            getFromApi() {
                this.loading = true;

                axios.get('/usuarios/0/cartazes-modelos')
                    .then((response) => {
                            let itens = response.data.items;
                            let configs = {};

                            this.itens.push(this.modeloEmBranco);

                            // region setando configs dos cartazes
                            for (const k in itens) {
                                configs = itens[k].json; //"json" é o nome do campo na tabela cartaz_modelo do db
                                configs = JSON.stringify(configs);
                                configs = JSON.parse(configs);

                                itens[k]['componenteDados'] = {id: 1};
                                itens[k]['configs'] = configs;

                                this.itens.push(itens[k]);
                            }

                            // this.itens.push(itens);
                            // this.itens = itens;
                            // endregion


                            this.loading = false;
                        }, (error) => {
                            console.log(error);
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        // this.errored = true
                    })
                    .finally(() => this.loading = false)
                ;
            },

            emitItem(item) {
                this.$emit("emitItem", {item: item});
            },
        },
    }
</script>
